import { useMediaQuery } from 'usehooks-ts'
import { SansText } from '../SansText/SansText'
import { SansTitle } from '../SansTitle/SansTitle'
import { SerifTitle } from '../SerifTitle/SerifTitle'
import {
  SectionContainer,
  TitleContainer,
} from './CollectionTextSection.styles'
import type { CollectionTextSectionProps } from './CollectionTextSection.types'

export const CollectionTextSection = ({
  title,
  upperTitle,
  paragraph,
}: CollectionTextSectionProps): JSX.Element => {
  const isMinWidth992px = useMediaQuery('(min-width: 992px)')

  return (
    <SectionContainer>
      {(upperTitle || title) && (
        <TitleContainer>
          {upperTitle && (
            <SansTitle tracking="wide" color="primary" size="sm" as="h3">
              {upperTitle}
            </SansTitle>
          )}

          {title && (
            <SerifTitle
              as="h2"
              size={isMinWidth992px ? 'xl' : 'md'}
              color="primary"
            >
              {title}
            </SerifTitle>
          )}
        </TitleContainer>
      )}

      {paragraph && (
        <div>
          <SansText
            as="div"
            leading="loose"
            size={isMinWidth992px ? 'md' : 'base'}
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        </div>
      )}
    </SectionContainer>
  )
}
